import { render, staticRenderFns } from "./DRTabs.vue?vue&type=template&id=a2a980e0&scoped=true&"
import script from "./DRTabs.vue?vue&type=script&lang=js&"
export * from "./DRTabs.vue?vue&type=script&lang=js&"
import style0 from "./DRTabs.vue?vue&type=style&index=0&id=a2a980e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a980e0",
  null
  
)

export default component.exports